import React, {Component} from 'react';
import './policies.scss'
// import NavBar from '../navbar/navbar'
import NavBarTest from '../navbar/NavBarTest'
// import {Card} from 'antd'
import AppFooter from '../footer/footer';

class Terms extends Component {

    render() {


        return (
            <React.Fragment>
                <NavBarTest/>
                <div className="policies">

                    <section id="main">
                        <div className="container">
                            <article>
                                <h2 className="page-title">
                                    Introduction
                                </h2>
                                <p>
                                    Thank you for using the Zimble platform and the products, services and features we
                                    make available to you as part of the
                                    platform (collectively, the “Service”). Please read these Terms carefully before
                                    using the Service. By using the
                                    Service, the user ("You") has accepted these Terms of Use. If You do not accept
                                    these Terms of Use, do not use the
                                    Service. By using the Service, you represent that you are of legal age or have legal
                                    guardianship to form a binding
                                    contract with Zimble.
                                </p>
                                <h3 className="the-zimble-policies-header">
                                    Our Service
                                </h3>
                                <p>
                                    The Service allows you to discover, watch and share educational videos and other
                                    content to others. It also allows you
                                    to ask, answer a question or share ideas. The Service provides a forum for people to
                                    connect, inform, and inspire others
                                    across the globe, and acts as a distribution platform for educators, teachers across
                                    the globe to provide educational
                                    content to young learners across the globe.
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    Your Service Provider
                                </h3>

                                <p>
                                    The entity providing the Service is Zimble (referred to as “Zimble”, “we”, “us”, or
                                    “our”).
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    Applicable Terms
                                </h3>

                                <p>
                                    Your use of the Service is subject to these terms, the Zimble Community Guidelines
                                    and the Policy, Safety and Copyright
                                    Policies which may be updated from time to time (together, this "Agreement"). Your
                                    Agreement with us will also include
                                    the Advertising on Zimble Policies if you provide advertising or sponsorships to the
                                    Service or incorporate paid
                                    promotions in your content. Any other links or references provided in these terms
                                    are for informational use only and are
                                    not part of the Agreement.
                                </p>

                                <p>
                                    Please read this Agreement carefully and make sure you understand it. If you do not
                                    understand the Agreement, or do not
                                    accept any part of it, then you may not use the Service.
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    Who may use the Service?
                                </h3>
                                <p>
                                    <b>Age Requirements</b>
                                </p>
                                <p>
                                    You must be at least 16 years old to upload content to the Service. However,
                                    children of all ages may view the content
                                    available on Zimble if enabled by a parent or legal guardian.
                                </p>
                                <p>
                                    <b>
                                        Permission by Parent or Guardian
                                    </b>
                                </p>
                                <p>
                                    If you are under 18, you represent that you have your parent or guardian’s
                                    permission to use the Service. Please have
                                    them read this Agreement with you.
                                </p>
                                <p>
                                    If you are a parent or legal guardian of a user under the age of 18, by allowing
                                    your child to use the Service, you are
                                    subject to the terms of this Agreement and responsible for your child’s activity on
                                    the Service. You can find tools and
                                    resources to help you manage your family’s experience on Zimble in our Help Center.
                                </p>

                                <p>
                                    <b>
                                        Businesses
                                    </b>
                                </p>
                                <p>
                                    If you are using the Service on behalf of a company or organization, you represent
                                    that you have authority to act on
                                    behalf of that entity, and that such entity accepts this Agreement.
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    Your Use of the Service
                                </h3>

                                <p>
                                    <b>
                                        Content on the Service
                                    </b>
                                </p>
                                <p>
                                    The content on the Service includes videos, audio, graphics, photos, text (such as
                                    comments) and other materials whether
                                    provided by you, Zimble or a third-party (collectively, "Content”).
                                </p>
                                <p>
                                    Content is the responsibility of the person or entity that provides it to the
                                    Service. Zimble is under no obligation to
                                    host or serve Content. If you see any Content you believe does not comply with this
                                    Agreement, including by violating
                                    the Community Guidelines or the law, you can report it to us.
                                </p>

                                <p>
                                    <b>
                                        Zimble Educational Channels
                                    </b>
                                </p>
                                <p>
                                    You can use parts of the Service, such as browsing and searching for Content,
                                    without having a Zimble account. However,
                                    you do need a Zimble account to use some features. With a Zimble account, you may be
                                    able to download
                                    videos, ask question and more.
                                </p>
                                <p>
                                    To protect your Zimble account, keep your password confidential. You should not
                                    reuse your Zimble account password on
                                    third-party applications. Learn more about keeping your Zimble account secure,
                                    including what to do if you learn of any
                                    unauthorized use of your password or Zimble account.
                                </p>
                                <p>
                                    <b>
                                        Your Information
                                    </b>
                                </p>

                                <p>
                                    Our Privacy Policy explains how we treat your personal data and protect your privacy
                                    when you use the Service. The
                                    Zimble Kids Privacy Notice provides additional information about our privacy
                                    practices that are specific to Zimble Kids.
                                </p>
                                <p>
                                    We will process any audio or audiovisual content uploaded by you to the Service in
                                    accordance with the Zimble Data
                                    Processing Terms.
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    Permissions and Restrictions
                                </h3>

                                <p>
                                    You may access and use the Service as made available to you, as long as you comply
                                    with this Agreement and applicable
                                    law. You may view or listen to Content for your personal, non-commercial use.
                                </p>

                                <p>
                                    <b>
                                        The following restrictions apply to your use of the Service. You are not allowed
                                        to:
                                    </b>
                                </p>
                                <p>
                                    <li> access, reproduce, download, distribute, transmit, broadcast, display, sell,
                                        license, alter, modify or otherwise use any
                                        part of the Service or any Content except: (a) as expressly authorized by the
                                        Service; or (b) with prior written
                                        permission from Zimble and, if applicable, the respective rights holders;
                                    </li>
                                </p>
                                <p>
                                    <li>circumvent, disable, fraudulently engage with, or otherwise interfere with any
                                        part of the Service (or attempt to do any
                                        of these things), including security-related features or features that (a)
                                        prevent or restrict the copying or other use
                                        of Content or (b) limit the use of the Service or Content;
                                    </li>
                                </p>

                                <p>
                                    <li> access the Service using any automated means (such as robots, botnets or
                                        scrapers)
                                    </li>
                                </p>
                                <p>
                                    <li>collect or harvest any information that might identify a person (for example,
                                        usernames), unless permitted by that
                                        person or allowed under section (3) above;
                                    </li>
                                </p>

                                <p>
                                    <li> use the Service to distribute unsolicited promotional or commercial content or
                                        other unwanted or mass solicitations;
                                    </li>
                                </p>

                                <p>
                                    <li>cause or encourage any inaccurate measurements of genuine user engagement with
                                        the Service, including by paying people
                                        or providing them with incentives to increase a video’s views, likes, or
                                        dislikes, or to increase a channel’s
                                        subscribers, or otherwise manipulate metrics in any manner;
                                    </li>
                                </p>

                                <p>
                                    <li>
                                        misuse any reporting, flagging, complaint, dispute, or appeals process,
                                        including by making groundless, vexatious, or
                                        frivolous submissions;
                                    </li>
                                </p>

                                <p>
                                    <li>
                                        run contests on or through the Service that do not comply with Zimble’s contest
                                        policies and guidelines;
                                    </li>
                                </p>

                                <p>
                                    <li>
                                        use the Service to view or listen to Content other than for personal,
                                        non-commercial use (for example, you may not
                                        publicly screen videos or stream music from the Service);
                                    </li>
                                </p>

                                <p>
                                    <li>
                                        use the Service to (a) sell any advertising, sponsorships, or promotions placed
                                        on, around, or within the Service or
                                        Content, other than those allowed in the Advertising on Zimble policies (such as
                                        compliant product placements); or (b)
                                        sell advertising, sponsorships, or promotions on any page of any website or
                                        application that only contains Content from
                                        the Service or where Content from the Service is the primary basis for such
                                        sales (for example, selling ads on a webpage
                                        where Zimble videos are the main draw for users visiting the webpage).
                                    </li>
                                </p>

                                <p>
                                    <li>
                                        Use the service to upload content to promote any specific religion or political
                                        agenda.
                                    </li>
                                </p>

                                <p>
                                    <li>
                                        Strictly prohibited from uploading any content with any crude language,
                                        pornographic imagery, or content considered
                                        unsuitable for children under 18years old.
                                    </li>
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    Reservation
                                </h3>
                                <p>
                                    Using the Service does not give you ownership of or rights to any aspect of the
                                    Service, including user names or any
                                    other Content posted by others or Zimble
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    Changes to the Service
                                </h3>
                                <p>
                                    Zimble is constantly changing and improving the Service. We may also need to alter
                                    or discontinue the Service, or any
                                    part of it, in order to make performance or security improvements, change
                                    functionality and features, make changes to
                                    comply with law, or prevent illegal activities on or abuse of our systems. These
                                    changes may affect all users, some
                                    users or even an individual user. Whenever reasonably possible, we will provide
                                    notice when we discontinue or make
                                    material changes to our Service that will have an adverse impact on the use of our
                                    Service. However, you understand and
                                    agree that there will be times when we make such changes without notice, such as
                                    where we feel we need to take action to
                                    improve the security and operability of our Service, prevent abuse, or comply with
                                    legal requirements.
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    Your Content and Conduct
                                </h3>

                                <p>
                                    <b>
                                        Uploading Content
                                    </b>
                                </p>
                                <p>
                                    If you have a Zimble channel, you may be able to upload Content to the Service. You
                                    may use your Content to promote your
                                    educational platform and unique ideas. If you choose to upload Content, you must not
                                    submit to the Service any Content
                                    that does not comply with this Agreement (including the Zimble Community Guidelines)
                                    or the law. For example, the
                                    Content you submit must not include third-party intellectual property (such as
                                    copyrighted material) unless you have
                                    permission from that party or are otherwise legally entitled to do so. You are
                                    legally responsible for the Content you
                                    submit to the Service. We may use automated systems that analyze your Content to
                                    help detect infringement and abuse,
                                    such as spam, malware, and illegal content.
                                </p>

                                <p>
                                    <b>
                                        Rights you Grant
                                    </b>
                                </p>

                                <p>
                                    You retain ownership rights in your Content. However, we do require you to grant
                                    certain rights to Zimble and other
                                    users of the Service, as described below.
                                </p>

                                <p>
                                    <b>
                                        License to Zimble
                                    </b>
                                </p>

                                <p>
                                    By providing Content to the Service, you grant to Zimble a worldwide, non-exclusive,
                                    royalty-free, sublicensable and
                                    transferable license to use that Content (including to reproduce, distribute,
                                    prepare derivative works, display and
                                    perform it) in connection with the Service and Zimble’s (and its successors' and
                                    Affiliates') business, including for
                                    the purpose of promoting and redistributing part or all of the Service.
                                </p>

                                <p>
                                    <b>
                                        License to Other Users

                                    </b>
                                </p>

                                <p>
                                    You also grant each other user of the Service a worldwide, non-exclusive,
                                    royalty-free license to access your Content
                                    through the Service, and to use that Content, including to reproduce, distribute,
                                    prepare derivative works, display, and
                                    perform it, only as enabled by a feature of the Service (such as video playback or
                                    embeds). For clarity, this license
                                    does not grant any rights or permissions for a user to make use of your Content
                                    independent of the Service.
                                </p>

                                <p>
                                    <b>
                                        Duration of License
                                    </b>
                                </p>
                                <p>
                                    The licenses granted by you continue for a commercially reasonable period of time
                                    after you remove or delete your
                                    Content from the Service. You understand and agree, however, that Zimble may retain,
                                    but not display, distribute, or
                                    perform, server copies of your videos that have been removed or deleted.
                                </p>

                                <p>
                                    <b>
                                        Removing Your Content
                                    </b>
                                </p>

                                <p>
                                    You may remove your Content from the Service at any time. You also have the option
                                    to make a copy of your Content before
                                    removing it. You must remove your Content if you no longer have the rights required
                                    by these terms. However, Zimble still
                                    owns rights to any content uploaded on the site unless it is Copyrighted.
                                </p>

                                <p>
                                    <b>
                                        Removal of Content By Zimble
                                    </b>
                                </p>
                                <p>
                                    If we reasonably believe that any Content is in breach of this Agreement or may
                                    cause harm to Zimble, our users, or
                                    third parties, we may remove or take down that Content in our discretion. We will
                                    notify you with the reason for our
                                    action unless we reasonably believe that to do so: (a) would breach the law or the
                                    direction of a legal enforcement
                                    authority or would otherwise risk legal liability for Zimble or our Affiliates; (b)
                                    would compromise an investigation or
                                    the integrity or operation of the Service; or (c) would cause harm to any user,
                                    other third party, Zimble or our
                                    Affiliates. You can learn more about reporting and enforcement, including how to
                                    appeal on the Troubleshooting page of
                                    our Help Center. If you upload content that is in direct violation of Zimble
                                    policies and terms, Zimble will revoke your
                                    access indefinitely.
                                </p>
                                <p>
                                    <b>
                                        Copyright Protection
                                    </b>
                                </p>

                                <p>
                                    We provide information to help copyright holders manage their intellectual property
                                    online in our Zimble Copyright
                                    Center. If you believe your copyright has been infringed on the Service, please send
                                    us a notice.
                                </p>
                                <p>
                                    We respond to notices of alleged copyright infringement according to the process in
                                    our Zimble Copyright Center, where
                                    you can also find information about how to resolve a copyright strike. Zimble 's
                                    policies provide for the termination,
                                    in appropriate circumstances, of repeat infringers’ access to the Service.
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    Account Suspension & Termination
                                </h3>

                                <p>
                                    <b>
                                        Terminations and Suspensions by Zimble for Cause
                                    </b>
                                </p>
                                <p>
                                    Zimble may suspend or terminate your access, your Zimble account, or your Zimble
                                    account’s access to all or part of the
                                    Service if (a) you materially or repeatedly breach this Agreement; (b) we are
                                    required to do so to comply with a legal
                                    requirement or a court order; or (c) we believe there has been conduct that creates
                                    (or could create) liability or harm
                                    to any user, other third party, Zimble or our Affiliates.
                                </p>

                                <p>
                                    <b>
                                        Terminations by Zimble for Service Changes
                                    </b>
                                </p>
                                <p>
                                    Zimble may terminate your access, or your Zimble account’s access to all or part of
                                    the Service if Zimble believes, in
                                    its sole discretion, that provision of the Service to you is no longer commercially
                                    viable.
                                </p>

                                <p>
                                    <b>
                                        Notice for Termination or Suspension
                                    </b>
                                </p>

                                <p>
                                    We will notify you with the reason for termination or suspension by Zimble unless we
                                    reasonably believe that to do so:
                                    (a) would violate the law or the direction of a legal enforcement authority, or
                                    would otherwise risk legal liability for
                                    Zimble or our Affiliates; (b) would compromise an investigation or the integrity or
                                    operation of the Service; or (c)
                                    would cause harm to any user, other third party, Zimble or our Affiliates. Where
                                    Zimble is terminating your access for
                                    Service changes, where reasonably possible, you will be provided with sufficient
                                    time to export your Content from the
                                    Service.
                                </p>
                                <p><b>
                                    Effect of Account Suspension or Termination
                                </b></p>
                                <p>
                                    If your Zimble account is terminated or your Zimble account’s access to the Service
                                    is restricted, you may continue
                                    using certain aspects of the Service (such as viewing only) without an account, and
                                    this Agreement will continue to
                                    apply to such use. If you believe your Zimble account has been terminated in error,
                                    you can appeal by sending us an email at <b> support@thezimble.com</b>
                                </p>
                                <h3 className="the-zimble-policies-header">
                                    About Software in the Service
                                </h3>

                                <p>
                                    <b>
                                        Downloadable Software
                                    </b>
                                </p>

                                <p>
                                    When the Service requires or includes downloadable software you give permission for
                                    that software to update
                                    automatically on your device once a new version or feature is available, subject to
                                    your device settings. Unless that
                                    software is governed by additional terms which provide a license, Zimble gives you a
                                    personal, worldwide, royalty-free,
                                    non-assignable and non-exclusive license to use the software provided to you by
                                    Zimble as part of the Service. This
                                    license is for the sole purpose of enabling you to use and enjoy the benefit of the
                                    Service as provided by Zimble, in
                                    the manner permitted by this Agreement. You are not allowed to copy, modify,
                                    distribute, sell, or lease any part of the
                                    software, or to reverse-engineer or attempt to extract the source code of that
                                    software, unless laws prohibit these
                                    restrictions or you have Zimble’s written permission.
                                </p>

                                <p>
                                    <b>
                                        Open Source
                                    </b>
                                </p>
                                <p>
                                    Software used in our Service may be offered under an open source license that we
                                    make available to you. There may be
                                    provisions in an open source license that expressly override some of these terms, so
                                    please be sure to read those
                                    licenses.
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    Other Legal Terms
                                </h3>

                                <p>
                                    <b>
                                        Warranty Disclaimer
                                    </b>
                                </p>

                                <p>
                                    OTHER THAN AS EXPRESSLY STATED IN THIS AGREEMENT OR AS REQUIRED BY LAW, THE SERVICE
                                    IS PROVIDED “AS IS” AND ZIMBLE DOES
                                    NOT MAKE ANY SPECIFIC COMMITMENTS OR WARRANTIES ABOUT THE SERVICE. FOR EXAMPLE, WE
                                    DON’T MAKE ANY WARRANTIES ABOUT: (A)
                                    THE CONTENT PROVIDED THROUGH THE SERVICE; (B) THE SPECIFIC FEATURES OF THE SERVICE,
                                    OR ITS ACCURACY, RELIABILITY,
                                    AVAILABILITY, OR ABILITY TO MEET YOUR NEEDS; OR (C) THAT ANY CONTENT YOU SUBMIT WILL
                                    BE ACCESSIBLE ON THE SERVICE.
                                </p>

                                <p>
                                    <b>
                                        Limitation of Liability
                                    </b>
                                </p>

                                <p>
                                    EXCEPT AS REQUIRED BY APPLICABLE LAW, ZIMBLE, ITS AFFILIATES, OFFICERS, DIRECTORS,
                                    EMPLOYEES AND AGENTS WILL NOT BE
                                    RESPONSIBLE FOR ANY LOSS OF PROFITS, REVENUES, BUSINESS OPPORTUNITIES, GOODWILL, OR
                                    ANTICIPATED SAVINGS; LOSS OR
                                    CORRUPTION OF DATA; INDIRECT OR CONSEQUENTIAL LOSS; PUNITIVE DAMAGES CAUSED BY:
                                </p>
                                <p>
                                    ERRORS, MISTAKES, OR INACCURACIES ON THE SERVICE;
                                </p>

                                <p>
                                    PERSONAL INJURY OR PROPERTY DAMAGE RESULTING FROM YOUR USE OF THE SERVICE;
                                </p>
                                <p>
                                    ANY UNAUTHORIZED ACCESS TO OR USE OF THE SERVICE;
                                </p>
                                <p>
                                    ANY INTERRUPTION OR CESSATION OF THE SERVICE;
                                </p>
                                <p>
                                    ANY VIRUSES OR MALICIOUS CODE TRANSMITTED TO OR THROUGH THE SERVICE BY ANY THIRD
                                    PARTY;
                                </p>
                                <p>
                                    ANY CONTENT WHETHER SUBMITTED BY A USER OR ZIMBLE, INCLUDING YOUR USE OF CONTENT;
                                    AND/OR
                                </p>
                                <p>
                                    THE REMOVAL OR UNAVAILABILITY OF ANY CONTENT.
                                </p>
                                <p>
                                    THIS PROVISION APPLIES TO ANY CLAIM, REGARDLESS OF WHETHER THE CLAIM ASSERTED IS
                                    BASED ON WARRANTY, CONTRACT, TORT, OR
                                    ANY OTHER LEGAL THEORY.
                                </p>
                                <p>
                                    ZIMBLE AND ITS AFFILIATES’ TOTAL LIABILITY FOR ANY CLAIMS ARISING FROM OR RELATING
                                    TO THE SERVICE IS LIMITED TO THE
                                    GREATER OF: (A) THE AMOUNT OF REVENUE THAT ZIMBLE HAS PAID TO YOU FROM YOUR USE OF
                                    THE SERVICE IN THE 12 MONTHS BEFORE
                                    THE DATE OF YOUR NOTICE, IN WRITING TO ZIMBLE, OF THE CLAIM; AND (B) USD $500.
                                </p>

                                <p>
                                    <b>
                                        Indemnity
                                    </b>
                                </p>

                                <p>
                                    To the extent permitted by applicable law, you agree to defend, indemnify and hold
                                    harmless Zimble, its Affiliates,
                                    officers, directors, employees and agents, from and against any and all claims,
                                    damages, obligations, losses,
                                    liabilities, costs or debt, and expenses (including but not limited to attorney's
                                    fees) arising from: (i) your use of
                                    and access to the Service; (ii) your violation of any term of this Agreement; (iii)
                                    your violation of any third party
                                    right, including without limitation any copyright, property, or privacy right; or
                                    (iv) any claim that your Content
                                    caused damage to a third party. This defense and indemnification obligation will
                                    survive this Agreement and your use of
                                    the Service.
                                </p>

                                <p>
                                    <b>
                                        Third-Party Links
                                    </b>
                                </p>

                                <p>
                                    The Service may contain links to third-party websites and online services that are
                                    not owned or controlled by Zimble.
                                    Zimble has no control over, and assumes no responsibility for, such websites and
                                    online services. Be aware when you
                                    leave the Service; we suggest you read the terms and privacy policy of each
                                    third-party website and online service that
                                    you visit.
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    About this Agreement
                                </h3>
                                <p>
                                    <b>
                                        Modifying this Agreement
                                    </b>
                                </p>

                                <p>
                                    We may modify this Agreement, for example, to reflect changes to our Service or for
                                    legal, regulatory, or security
                                    reasons. Zimble will provide reasonable advance notice of any material modifications
                                    to this Agreement and the
                                    opportunity to review them, except that modifications addressing newly available
                                    features of the Service or
                                    modifications made for legal reasons may be effective immediately without notice.
                                    Modifications to this Agreement will
                                    only apply going forward. If you do not agree to the modified terms, you should
                                    remove any Content you have uploaded and
                                    discontinue your use of the Service.
                                </p>

                                <p>
                                    <b>
                                        Continuation of this Agreement
                                    </b>
                                </p>

                                <p>
                                    If your use of the Service ends, the following terms of this Agreement will continue
                                    to apply to you: “Other Legal
                                    Terms”, “About This Agreement”, and the licenses granted by you will continue as
                                    described under “Duration of License”.

                                </p>
                                <p>
                                    <b>
                                        Severance
                                    </b>
                                </p>

                                <p>
                                    If it turns out that a particular term of this Agreement is not enforceable for any
                                    reason, this will not affect any
                                    other terms.
                                </p>

                                <p>
                                    <b>
                                        No Waiver
                                    </b>
                                </p>

                                <p>
                                    If you fail to comply with this Agreement and we do not take immediate action, this
                                    does not mean that we are giving up
                                    any rights that we may have (such as the right to take action in the future).
                                </p>

                                <p>
                                    <b>
                                        Interpretation
                                    </b>
                                </p>

                                <p>
                                    In these terms, “include” or “including” means “including but not limited to,” and
                                    any examples we give are for
                                    illustrative purposes.
                                </p>

                                <p>
                                    <b>
                                        Governing Law
                                    </b>
                                </p>

                                <p>
                                    All claims arising out of or relating to these terms or the Service will be governed
                                    by California law, except
                                    California’s conflict of laws rules, and will be litigated exclusively in the
                                    federal or state courts of Santa Clara
                                    County, California, USA. You and Zimble consent to personal jurisdiction in those
                                    courts.
                                </p>

                                <p>
                                    <b>
                                        Limitation on Legal Action
                                    </b>
                                </p>

                                <p>
                                    YOU AND ZIMBLE AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO THE
                                    SERVICES MUST COMMENCE WITHIN ONE (1)
                                    YEAR AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS
                                    PERMANENTLY BARRED
                                </p>

                            </article>

                        </div>

                    </section>

                </div>
                <div className='gradient-half-primary-v1'>
                    <AppFooter/>
                </div>
            </React.Fragment>
        )

    }

}

export default Terms